var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4248 7.92215C23.88 8.94078 24.0729 10.3293 24.4044 12.7164C24.9133 16.3802 25.1677 18.2121 24.6083 19.6349C24.1171 20.884 23.2103 21.9255 22.0407 22.5838C20.7084 23.3337 18.8589 23.3337 15.1598 23.3337H13.2649C9.56591 23.3337 7.71639 23.3337 6.38409 22.5838C5.21447 21.9255 4.30763 20.884 3.81649 19.6349C3.25704 18.2121 3.51147 16.3802 4.02034 12.7164C4.33076 10.4813 4.5196 9.12166 4.91606 8.12141M23.4248 7.92215C23.3359 7.72325 23.2371 7.53845 23.1252 7.36307C22.5217 6.41709 21.6582 5.66523 20.6382 5.19763C19.4807 4.66699 18.0404 4.66699 15.1598 4.66699H13.2649C10.3844 4.66699 8.94409 4.66699 7.78656 5.19763C6.76656 5.66523 5.90305 6.41709 5.29958 7.36307C5.15122 7.59564 5.0257 7.84478 4.91606 8.12141M23.4248 7.92215L23.3215 8.02545L22.3204 9.02659C18.4315 12.9155 16.4871 14.8599 14.0708 14.8599C11.6546 14.8599 9.71013 12.9155 5.82124 9.02659L4.91606 8.12141",
    stroke: "#FFFFFC",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage36);
export default __webpack_public_path__ + "static/media/Message 36.75cbbd59ff4fae90706b6e9d6f8eb94b.svg";
export { ForwardRef as ReactComponent };